/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Audit log entry with detailed information about user actions and system events
 * @export
 * @interface AuditLogDto
 */
export interface AuditLogDto {
    /**
     * Unique identifier for the audit log entry
     * @type {string}
     * @memberof AuditLogDto
     */
    id?: string;
    /**
     * UUID of the tenant associated with this audit log
     * @type {string}
     * @memberof AuditLogDto
     */
    tenantId?: string;
    /**
     * Name of the tenant associated with this audit log (for display)
     * @type {string}
     * @memberof AuditLogDto
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    resourceType?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    resourceId?: string;
    /**
     * When the action occurred
     * @type {Date}
     * @memberof AuditLogDto
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    ipAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    geographicLocation?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AuditLogDto
     */
    beforeValues?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AuditLogDto
     */
    afterValues?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AuditLogDto
     */
    fieldChanges?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    businessContext?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuditLogDto
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    errorMessage?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AuditLogDto
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof AuditLogDto
     */
    crossTenantAction?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    sourceTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    targetTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    relationshipId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    actingUserTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    category?: AuditLogDtoCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof AuditLogDto
     */
    severity?: AuditLogDtoSeverityEnum;
    /**
     * How the audit log was written: ASYNC (via Temporal), SYNC (synchronous), or FALLBACK (async failed)
     * @type {string}
     * @memberof AuditLogDto
     */
    auditLoggingMode?: string;
    /**
     * Latency in milliseconds from audit initiation to persistence
     * @type {number}
     * @memberof AuditLogDto
     */
    auditLatencyMs?: number;
}


/**
 * @export
 */
export const AuditLogDtoCategoryEnum = {
    Authentication: 'AUTHENTICATION',
    Authorization: 'AUTHORIZATION',
    DataModification: 'DATA_MODIFICATION',
    Administrative: 'ADMINISTRATIVE',
    SecurityEvent: 'SECURITY_EVENT',
    SystemError: 'SYSTEM_ERROR',
    ApiCall: 'API_CALL',
    SensitiveAccess: 'SENSITIVE_ACCESS',
    CrossTenantAccess: 'CROSS_TENANT_ACCESS',
    DataAccess: 'DATA_ACCESS',
    SystemConfiguration: 'SYSTEM_CONFIGURATION'
} as const;
export type AuditLogDtoCategoryEnum = typeof AuditLogDtoCategoryEnum[keyof typeof AuditLogDtoCategoryEnum];

/**
 * @export
 */
export const AuditLogDtoSeverityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type AuditLogDtoSeverityEnum = typeof AuditLogDtoSeverityEnum[keyof typeof AuditLogDtoSeverityEnum];


/**
 * Check if a given object implements the AuditLogDto interface.
 */
export function instanceOfAuditLogDto(value: object): value is AuditLogDto {
    return true;
}

export function AuditLogDtoFromJSON(json: any): AuditLogDto {
    return AuditLogDtoFromJSONTyped(json, false);
}

export function AuditLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditLogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'username': json['username'] == null ? undefined : json['username'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'action': json['action'] == null ? undefined : json['action'],
        'resourceType': json['resourceType'] == null ? undefined : json['resourceType'],
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'ipAddress': json['ipAddress'] == null ? undefined : json['ipAddress'],
        'userAgent': json['userAgent'] == null ? undefined : json['userAgent'],
        'geographicLocation': json['geographicLocation'] == null ? undefined : json['geographicLocation'],
        'beforeValues': json['beforeValues'] == null ? undefined : json['beforeValues'],
        'afterValues': json['afterValues'] == null ? undefined : json['afterValues'],
        'fieldChanges': json['fieldChanges'] == null ? undefined : json['fieldChanges'],
        'businessContext': json['businessContext'] == null ? undefined : json['businessContext'],
        'success': json['success'] == null ? undefined : json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'crossTenantAction': json['crossTenantAction'] == null ? undefined : json['crossTenantAction'],
        'sourceTenantId': json['sourceTenantId'] == null ? undefined : json['sourceTenantId'],
        'targetTenantId': json['targetTenantId'] == null ? undefined : json['targetTenantId'],
        'relationshipId': json['relationshipId'] == null ? undefined : json['relationshipId'],
        'actingUserTenantId': json['actingUserTenantId'] == null ? undefined : json['actingUserTenantId'],
        'category': json['category'] == null ? undefined : json['category'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'auditLoggingMode': json['auditLoggingMode'] == null ? undefined : json['auditLoggingMode'],
        'auditLatencyMs': json['auditLatencyMs'] == null ? undefined : json['auditLatencyMs'],
    };
}

export function AuditLogDtoToJSON(json: any): AuditLogDto {
    return AuditLogDtoToJSONTyped(json, false);
}

export function AuditLogDtoToJSONTyped(value?: AuditLogDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'userId': value['userId'],
        'username': value['username'],
        'sessionId': value['sessionId'],
        'action': value['action'],
        'resourceType': value['resourceType'],
        'resourceId': value['resourceId'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'ipAddress': value['ipAddress'],
        'userAgent': value['userAgent'],
        'geographicLocation': value['geographicLocation'],
        'beforeValues': value['beforeValues'],
        'afterValues': value['afterValues'],
        'fieldChanges': value['fieldChanges'],
        'businessContext': value['businessContext'],
        'success': value['success'],
        'errorMessage': value['errorMessage'],
        'metadata': value['metadata'],
        'crossTenantAction': value['crossTenantAction'],
        'sourceTenantId': value['sourceTenantId'],
        'targetTenantId': value['targetTenantId'],
        'relationshipId': value['relationshipId'],
        'actingUserTenantId': value['actingUserTenantId'],
        'category': value['category'],
        'severity': value['severity'],
        'auditLoggingMode': value['auditLoggingMode'],
        'auditLatencyMs': value['auditLatencyMs'],
    };
}

